import PropTypes from 'prop-types';
import React from 'react';
import SearchPanel from './search_panel';
import PageHeaderModule from '../module/page_header_module';
import { defineMessages, injectIntl } from 'react-intl';
import { decorateIntlMessages } from '../common/rosetta_formatted_message';

const i18nMessages = decorateIntlMessages(__filename, defineMessages({
  title: {
    id: 'placeholder',
    description: 'Search',
    defaultMessage: 'Search'
  }
}));

export const SearchInterface = ({ intl, ...props }) => (
  <div>
    <PageHeaderModule title={intl.formatMessage(i18nMessages.title)} />
    <SearchPanel {...props} />
  </div>
);

SearchInterface.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  })
};

export default injectIntl(SearchInterface);
